'use strict';

var dialog = require('./dialog'),
	linchpin = require('int_googletagmanager/linchpin/login'),
	linchpinError = require('int_googletagmanager/linchpin/error'),
	formPrepare = require('./pages/checkout/formPrepare');

/**
 * @private
 * @function
 * @description reset password dialog event handler
 */
var restPasswordDialogCallback = function () {
	var $form = $('[name$="_requestpassword"]'),
		$submit = $form.find('[name$="_requestpassword_send"]');

	$form.submit(function (e) {
		e.preventDefault();
		dialog.submit($submit.attr('name'), restPasswordDialogCallback);
	});
};



/**
 * @private
 * @function
 * @description add back-end errors to linchpin
 */
 var trackError = function ($container, alternativeName) {
	var error = $container.find('.error-form');
	if (error.length) {
		linchpinError.formErrorEventSingle([error], error, alternativeName);
	}
};

/**
 * @private
 * @function
 * @description Set active authorisation panel, init its switching with radio buttons
 */
var manageAuthorisationPanels = function() {
	var $authPanels = $('.login-column');
	var $panelControls = $authPanels.find('input[name*=authOption]');
	var $loginOptions = $authPanels.find('.login-option');

	$panelControls.on('click', function () {
		$loginOptions.removeClass('active');
		$(this).parents('.login-column').find('.login-option').addClass('active');
	});

	// make panel active if there is an error on load
	var $formError = $authPanels.find('.error-form');
	if ($formError.length) {
		$loginOptions.removeClass('active');
		$panelControls.prop('checked', false).parents('.checked').removeClass('checked');

		var $panelWithError = $formError.parents('.login-column');
		$panelWithError.find('[name*=authOption]').prop('checked', true);
		$panelWithError.find('.radio span').addClass('checked');
		$panelWithError.find('.login-option').addClass('active');
	}
};

/**
 * @function
 * @description init events for the loginPage
 */
exports.init = function () {
	//o-auth binding for which icon is clicked
	$('.oAuthIcon').bind('click', function () {
		$('#OAuthProvider').val(this.id);
	});

	//toggle the value of the rememberme checkbox
	$('#dwfrm_login_rememberme').bind('change', function () {
		if ($('#dwfrm_login_rememberme').attr('checked')) {
			$('#rememberme').val('true');
		} else {
			$('#rememberme').val('false');
		}
	});
	$('#password-reset').on('click', function (e) {
		e.preventDefault();
		dialog.open({
			url: $(e.target).attr('href'),
			options: {
				title: $(this).attr('title'),
				dialogClass: 'forgot-password-dialog dialog-show-loading',
				open: function() {
					formPrepare.init({
						continueSelector: '[name$="_requestpassword_send"]',
						formSelector: $('#PasswordResetForm'),
						replaceInvalidInput: true,
						keyup: false,
						autofillValidate: true
					});
					restPasswordDialogCallback();
					$(document).on('click', '.close-dialog-button', function() {
						dialog.close();
					});
				},
				width: 300
			}
		});
	});

	if ($('input[name=loginSucceeded]').length > 0) {
		var email = '';
		var status = $('input[name=loginSucceeded]').val();
		if ($('input[name*=_login_username').length > 0) {
			var email = $('input[name*=_login_username').val();
		} else if ($('input[name=loginEmail').length > 0) {
			var email = $('input[name=loginEmail').val();
		}

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			if (status && status !== 'null') {
				linchpin.loginEvent(status, email);
			}
		}
	}

	$('.login-box.create-account button').on('click', function () {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.registrationConfirmationAttemptEvent('Login Page');
		}
	});
	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		$('[id$="_ordertrack"] input.required, [id$="_login"] input.required, [id$="_login_register"] input.required')
		.on('focusout', function () {
			linchpinError.pushSingleErrorObject($(this));
		});
		// track backend errors
		trackError($('form[id$="login"]'), 'Email or Password');
		trackError($('.check-order-form'));
	}

	manageAuthorisationPanels();
};
